<template>
  <div class="pb-4 centrocusto-show-card-seeder">
    <el-card v-loading="isLoading">
      <div scope="header">
        <span class="cadastro-title">Seeders - {{ centroCusto.nome}}</span>
      </div>
      <el-row class="pt-4">
        <el-col>
          <table class="table table-hover">
            <thead class="thead">
            <tr>
              <th>Grupo Pergunta</th>
              <th>Usuário</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="bind in binds">
              <td>{{bind.pergunta_grupo_nome}}</td>
              <td>
                <el-select v-model="bind.user_id">
                  <el-option
                    :label="seeder.name"
                    :value="seeder.id"
                    :key="seeder.id"
                    v-for="seeder in list">{{ seeder.name}}
                  </el-option>
                </el-select>
              </td>
            </tr>
            </tbody>
          </table>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div align="right">
          <el-button type="warning" @click="toList()">Lista</el-button>
          <el-button type="primary" @click="handleSubmit()">Salvar</el-button>
          </div>
        </el-col>
      </el-row>

    </el-card>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import {Notification} from 'element-ui'

  export default {
    name: "seeder",
    data() {
      return {
        binds: null,
        centroCusto: null,
        isLoading: false
      }
    },
    computed: {
      ...mapState('Seeder', ['list']),
      centroCustoId() {
        return this.$route.params.centrocusto
      },
      bindsToPersist() {
        return {id: this.centroCustoId, binds: this.binds.map(item => ({id: item.id, user_id: item.user_id}))}
      }
    },
    methods: {
      ...mapActions('Seeder', ['setList']),
      ...mapActions('CentroCusto', ['updateSeeder']),
      handleSubmit() {
        try {
          this.updateSeeder(this.bindsToPersist)
          Notification.success("Seeders Atualizados com sucesso.")
        } catch (e) {
          Notification.error("Erro interno , contate o admistrador do sistema.")
        }
      },
    toList() {
      this.$router.push({name: 'centrocusto.index'})
    }
    },
    async mounted() {
      try {

        this.isLoading = true
        const psDataCentro = axios.get(`${process.env.API_PATH}/centrocusto/${this.centroCustoId}/seeder`)
        const psListSeeder = this.setList()
        const [{data}, seeders] = await Promise.all([psDataCentro, psListSeeder])
        this.centroCusto = data.centrocusto
        this.binds = data.binds

      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }

    }
  }
</script>

<style scoped>
  .table .thead th {
    color: #fff;
    background-color: #2E2E2E;
    border-color: #2E2E2E;
  }
</style>



// WEBPACK FOOTER //
// src/features/Centro/Seeder.vue